import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String,
    class: { type: String, default: "active" }
  }

  toggle(e) {
    e.preventDefault()

    const target = document.querySelector(this.targetValue)
    const className = this.classValue

    target.classList.toggle(className)
    this.element.classList.toggle(className)
    this.element.setAttribute('aria-expanded', this.element.classList.contains(className))
  }
}
